import React, { useContext, useMemo, useState } from "react";
import { Session } from "../../__generated__/graphql";
export type SessionDataType = Session | null;

export interface SessionContextType {
    session: SessionDataType | null;
    sessions: SessionDataType[];
    setSessions: (sessions: SessionDataType[]) => void;
    setSession: (session: SessionDataType) => void;
}

const SessionContext = React.createContext<SessionContextType | null>(null);
SessionContext.displayName = "SessionContext";

export const SessionProvider = ({ children }: { children: React.ReactNode }) => {
    const [session, setSession] = useState<SessionDataType>(null);
    const [sessions, setSessions] = useState<SessionDataType[]>([]);

    const value = useMemo(
        () => ({ session, sessions, setSession, setSessions }),
        [session, sessions]
    );

    return (
        <SessionContext.Provider value={value} >
            {children}
        </SessionContext.Provider>
    );
};

export const useSessionContext = () => {
    const context = useContext(SessionContext);
    if (!context) {
        throw new Error("useSessionContext must be used within a SessionProvider");
    }
    return context;
};
